module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/align-auto-90c88006c28e9e9107c4092e03f33e8d.svg";